// extracted by mini-css-extract-plugin
export var main = "main-module--main--b06a1";